import React from 'react';
import { Button } from './ui/Button';
interface HeroSectionProps {
  onOpenModal: () => void;
}
export function HeroSection({
  onOpenModal
}: HeroSectionProps) {
  return <section className="relative min-h-[100svh] flex items-center pt-[60px] overflow-hidden bg-brand-text" data-id="element-127">
      {/* Content */}
      <div className="container relative z-10 px-4 md:px-6 py-12 md:py-24" data-id="element-128">
        <div className="max-w-3xl mx-auto text-center" data-id="element-129">
          <p className="font-sans text-brand-gold font-bold tracking-[0.2em] uppercase text-xs md:text-sm mb-6" data-id="element-130">
            BBL Forever Young · Be Clinical San Ramon
          </p>
          <h1 className="font-playfair text-[32px] leading-[1.1] md:text-5xl lg:text-6xl text-white mb-6" data-id="element-131">
            Light Did This.
            <br data-id="element-132" />
            Your Skin Did The Rest.
          </h1>
          <p className="font-sans text-white/70 text-base md:text-lg leading-relaxed mb-10 max-w-xl mx-auto" data-id="element-133">
            BBL Forever Young uses broad-band light to erase sun damage, even
            skin tone, and trigger your skin's natural renewal response —
            nothing added, nothing injected, nothing altered.
          </p>
          <Button fullWidth className="md:w-auto text-sm md:text-base" onClick={onOpenModal} data-id="element-134">
            Book Your Free Consultation
          </Button>
          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-135">
            <div className="flex items-center gap-0.5" data-id="element-136">
              {[...Array(5)].map((_, i) => <svg key={i} className="w-4 h-4 text-brand-gold fill-current" viewBox="0 0 20 20" data-id="element-137">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-138" />
                </svg>)}
            </div>
            <span className="font-sans text-white/60 text-xs md:text-sm tracking-wide" data-id="element-139">
              250+ Reviews · 4.9 Stars · San Ramon, CA
            </span>
          </div>
        </div>
      </div>
    </section>;
}